import { useState, useEffect, useRef } from 'react'
import ContentFrame from 'components/Frame/ContentFrame';

export default function TabSelector({ 
    tabs = [], 
    selectedTabKey, 
    HandleTabChange = () => {}
}) {

    const [highlightStyle, setHighlightStyle] = useState({ width: 0, left: 0 })
    const tabRefs = useRef({})
    const containerRef = useRef(null)

    const UpdateTabHighlight = () => {

        const selectedTabRef = tabRefs.current[selectedTabKey]

        if (selectedTabRef && containerRef.current) {

            const containerRect = containerRef.current.getBoundingClientRect()
            const tabRect = selectedTabRef.getBoundingClientRect()
            const leftOffset = tabRect.left - containerRect.left
            
            setHighlightStyle({
                width: tabRect.width,
                left: leftOffset
            })

        }
    }

    useEffect(() => {
        const rafId = requestAnimationFrame(() => {
            UpdateTabHighlight()
        })

        window.addEventListener('resize', UpdateTabHighlight)

        return () => {
            cancelAnimationFrame(rafId)
            window.removeEventListener('resize', UpdateTabHighlight)
        }
    }, [tabs, selectedTabKey])

    return (
        <div className='min-w-0'>
            <ContentFrame>
                <div
                    ref={containerRef}
                    className="flex h-12 w-full min-w-0 p-1 items-stretch gap-x-1 relative"
                >
                    {highlightStyle.width > 0 && (
                        <div
                            className="absolute border border-orange-500 bg-orange-50 rounded-xl transition-all duration-300 ease-out pointer-events-none"
                            style={{
                                width: `${highlightStyle.width}px`,
                                left: `${highlightStyle.left}px`,
                                top: '0.375rem',
                                height: 'calc(100% - 0.75rem)'
                            }}
                        />
                    )}

                    {tabs.map((tab) => (
                        <div
                            key={tab.key}
                            ref={el => { if (el) tabRefs.current[tab.key] = el }}
                            className={`
                                flex min-w-0 flex-1 items-center justify-center px-2 sm:px-4 rounded-xl cursor-pointer relative z-10 text-center text-xs sm:text-sm truncate
                                2xl:flex-none 2xl:w-auto 2xl:shrink-0 2xl:whitespace-nowrap 2xl:overflow-visible 2xl:text-clip
                                hover:text-orange-600 transition-colors duration-200
                                ${tab.key === selectedTabKey ? 'text-orange-600 font-medium' : 'text-gray-700'}
                            `}
                            onClick={() => HandleTabChange(tab.key)}
                        >
                            {tab.text}
                        </div>
                    ))}
                </div>
                
            </ContentFrame>
        </div>
    )
}